import { onFind } from "@elements/init-modules-in-scope";

export function init() {
    let anchorLink = window.location.href.split('#')[1];
    onFind('#' + anchorLink, function (target) {
        const offsetPosition = target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 100;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        })
    });
}